import { AI, Api, TokenApi } from '@/utils/api'

// POST jobTitle jobDescription
export const sendJobDetails = async (jobTitle, jobDescription, pk) => {
  try {
    // Send jobTitle and jobDescription to the backend to get questions
    const res = await AI.post('prep/session', { Jobtitle: jobTitle, user: 1 })
    // console.log(res)
    return res
  } catch (error) {
    console.error('Error:', error)
    alert('Send proper details', error)
  }
}
export const sendAudio = async (sessionId, qusNum, audioFile) => {
  try {
    const formData = new FormData()
    // console.log(audioFile)
    const res = await AI.post(
      'prep/ok',
      {
        param: {
          qusNum: qusNum
        },
        // audioFile
        formData: {
          audioFile: { audioFile }
        }
      },
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
    // console.log('feedback:', res)
    return res
  } catch (error) {
    alert(error)
  }
}

export const sendQuesAudio = async (question, audioFile) => {
  try {
    const formData = new FormData()
    // console.log(audioFile)
    const res = await AI.post(
      'prep/ok',
      {
        param: {
          qusNum: question
        },
        // audioFile
        formData: {
          audioFile: { audioFile }
        }
      },
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
    // console.log('feedback:', res)
    return res
  } catch (error) {
    alert(error)
  }
}

export const fetchQuestionBank = async () => {
  try {
    const res = await AI.get('prep/questions')
    // console.log(res.data)
    return res
  } catch (error) {
    alert('Error fetching Questions: ' + error.message)
    throw error
  }
}

export const sendFeedback = async (sessionId, session_type, feedback, isThumbsUp) => {
  try {
    const data = {
      session_type: session_type,
      session_id: sessionId,
      feedback,
      thumbsup: isThumbsUp
    }
    // Send jobTitle and jobDescription to the backend to get questions
    const res = await AI.post('prep/feedback/', data)
    return res
  } catch (error) {
    // alert('Error sending feedback: ' + error.message)
    throw error
  }
}
